@if (isVisible() && anchor(); as active) {
  <div class="eva-context-bar">
    <mat-icon class="eva-context-marker"
              small>place</mat-icon>
    <span class="body-small">Context:</span>

    <div class="eva-context-title">
      @if (active.applicantId && active.applicantName) {
        <a matButton="outlined"
           color="primary"
           class="eva-context-target"
           [matTooltip]="decodedApplicantName()"
           (click)="navigateToApplicant(active.applicantId)">
          <mat-icon class="eva-context-marker"
                    small>person</mat-icon>
          <span class="eva-context-target-text">{{ truncatedApplicantName() }}</span>
        </a>
      }

      @if (active.policyId) {
        <span class="eva-context-separator">:</span>
        <a matButton="outlined"
           color="primary"
           class="eva-context-target"
           [href]="navigateToPolicy()"
           [matTooltip]="decodedPolicyNumber()">
          <span class="eva-context-target-text">{{ truncatedPolicyNumber() }}</span>
        </a>
      }
    </div>

    <button type="button"
            mat-icon-button
            class="eva-context-action"
            (click)="clear()"
            matTooltip="Clear EVA context">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}